import markGUAsAsNeedingUpdate from "./markGUAsAsNeedingUpdate";

export default function markGUAsAsNeedingUpdateAll (student, year) {
  if (!student || !student.assessments) return Promise.reject()
  console.log('markGUAsAsNeedingUpdateAll', student, year)
  const updates = Object.keys(student.assessments).map(assessmentId => {
    console.log('assessmentId', assessmentId)
    return markGUAsAsNeedingUpdate(student, assessmentId, year)
  })
  return Promise.all(updates)
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/markGUAsAsNeedingUpdateAll.js